"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsetR = void 0;
const unset = require("lodash/unset");
const unsetR = (obj, pattern) => {
    unset(obj, pattern);
    return obj;
};
exports.unsetR = unsetR;
exports.default = exports.unsetR;
//# sourceMappingURL=unsetR.js.map